/* GENERADO por scripts/shopify-theme/make-src.js desde assets/js/ab-socialproof.js: no editar a mano. Test congelado en A: solo informa a GA4 y Clarity. */
/* ExtraCM — A/B test: social proof near the Add to Cart
   Experiment "socialproof_join":
     · A (control) → page as-is, nothing added.
     · B (variant) → "Join 115,000+ men standing taller" line right below the ATC.
   50/50, sticky per visitor (localStorage). Reports the variant to GA4 (user property +
   experiment_impression event) and to Clarity (tag), so you can compare add_to_cart by variant.

   TEST: force a variant with  /buy/#ab-a  or  /buy/#ab-b .
   Reset:  localStorage.removeItem('extracm_ab_socialproof')  then reload.
*/
(function () {
  'use strict';

  var KEY = 'extracm_ab_socialproof';
  var EXP = 'socialproof_join';

  // ---- assign / read sticky variant ----
  var variant = null;
  try { variant = localStorage.getItem(KEY); } catch (e) {}
  if (variant !== 'A' && variant !== 'B') {
    variant = (Math.random() < 0.5) ? 'A' : 'B';
    try { localStorage.setItem(KEY, variant); } catch (e) {}
  }
  // manual override for testing
  if (location.hash.indexOf('ab-a') !== -1) variant = 'A';
  if (location.hash.indexOf('ab-b') !== -1) variant = 'B';
  variant = 'A';   // CONGELADO durante el test de tema (theme A/B): una sola variable a testear (color de fondo)
  window.__abSocialproof = variant;

  // ---- report which variant this visitor is in ----
  try {
    if (typeof gtag === 'function') {
      gtag('set', 'user_properties', { ab_socialproof: variant });
      gtag('event', 'experiment_impression', { exp_name: EXP, variant: variant });
    }
  } catch (e) {}
  try { if (typeof clarity === 'function') clarity('set', 'ab_socialproof', variant); } catch (e) {}

  if (variant !== 'B') return;   // control: render nothing

  // ---- variant B: inject the social-proof line below the Add to Cart ----
  var css = ''
    + '.sp-join{display:flex;align-items:center;justify-content:center;gap:.5rem;'
    +   'margin:.7rem 0 0;font-size:.86rem;font-weight:600;color:#8AAABB;'
    +   'animation:spFade .4s ease-out}'
    + '.sp-join strong{color:#00C8F0;font-weight:800}'
    + '.sp-join__dot{width:8px;height:8px;border-radius:50%;background:#3DDC84;flex:none;'
    +   'box-shadow:0 0 0 0 rgba(61,220,132,.5);animation:spPulse 1.8s ease-out infinite}'
    + '@keyframes spPulse{0%{box-shadow:0 0 0 0 rgba(61,220,132,.5)}100%{box-shadow:0 0 0 9px rgba(61,220,132,0)}}'
    + '@keyframes spFade{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}';
  var styleEl = document.createElement('style');
  styleEl.id = 'sp-join-styles';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function inject() {
    var atc = document.getElementById('addBtn');
    if (!atc || document.getElementById('sp-join')) return;
    var el = document.createElement('div');
    el.id = 'sp-join';
    el.className = 'sp-join';
    el.innerHTML = '<span class="sp-join__dot" aria-hidden="true"></span> Join <strong>115,000+ men</strong> standing taller';
    atc.insertAdjacentElement('afterend', el);   // right below the button, above the trust row
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
})();
